/*
 *
 * BlogPosts
 *
 */

import React from "react";
import { connect } from "react-redux";
import { setTitle, delayedDispatch, setBreadcrumb, updateCrumb } from "store/actions";
import { Helmet } from "react-helmet";
import { Table } from "components";
import { API, Endpoints } from "utils/api";
import { push } from "connected-react-router";
import Strings from "utils/strings";
import { translate } from "utils/utils";
import { DateTime } from "luxon";
import "./styles.scss";

export class BlogPosts extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            blogPosts: [],
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(setTitle(Strings.sidebar.blogPosts));

        delayedDispatch(
            setBreadcrumb(() => {
                return {
                    locations: [
                        {
                            text: Strings.sidebar.blogPosts,
                            icon: "testimonial",
                        },
                    ],
                };
            })
        );

        this.getBlogPosts();
    }

    componentDidUpdate() {
        const { dispatch } = this.props;
        dispatch(updateCrumb());
    }

    onAdd() {
        const { dispatch } = this.props;
        dispatch(push("/blog-posts/new"));
    }

    getBlogPosts = async () => {
        const response = await API.get({
            url: Endpoints.uriBlogPosts(),
        });

        if (response.ok) {
            this.setState({ blogPosts: response.data.results.posts || [] });
        }
    };

    patchBlogPost = async (original: any) => {
        let body = { active: !original.active };

        const response = await API.patch({
            url: Endpoints.uriBlogPosts(original._id),
            data: body,
        });

        if (response.ok) {
            this.setState({ blogPosts: response.data.results.posts });
        }
    };

    render() {
        const { blogPosts = [] } = this.state;
        const { dispatch } = this.props;

        return (
            <React.Fragment>
                <Helmet>
                    <title>{Strings.sidebar.blogPosts}</title>
                    <meta name="description" content="Description of Blog Posts" />
                </Helmet>
                <Table
                    title={{
                        icon: "testimonial",
                        title: Strings.sidebar.blogPosts,
                    }}
                    data={blogPosts}
                    columns={[
                        {
                            Header: Strings.pages.title,
                            id: "name",
                            accessor: (row: any) => translate(row.title),
                        },
                        {
                            Header: Strings.fields.date,
                            id: "date",
                            accessor: (row: any) => DateTime.fromISO(row.date).toFormat("dd/MM/yyyy"),
                            maxWidth: 150,
                        },
                    ]}
                    isSinglePage
                    paginated={false}
                    add={{
                        label: String(
                            Strings.formatString(Strings.generic.addNewM, Strings.blogPosts.single.toLowerCase())
                        ),
                        onClick: () => this.onAdd(),
                    }}
                    actions={{
                        edit: (original, value) => ({
                            onClick: () => dispatch(push(`/blog-posts/${original._id}`)),
                        }),
                        toggle: (original, value) => ({
                            value: original.active,
                            onChange: () => this.patchBlogPost(original),
                        }),
                    }}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(BlogPosts);
